import React from 'react';

const DocumentApprovedIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 17L19 22L15.5 18.5L17 17L19 19L22.5 15.5L24 17ZM6.5 2C5.39 2 4.5 2.89 4.5 4V20C4.5 21.11 5.39 22 6.5 22H14.31C13.78 21.09 13.5 20.05 13.5 19C13.5 18.67 13.53 18.33 13.58 18H6.5V16H14.31C14.77 15.2 15.41 14.5 16.18 14H6.5V12H18.5V13.08C18.83 13.03 19.17 13 19.5 13C19.84 13 20.17 13.03 20.5 13.08V8L14.5 2M13.5 3.5L19 9H13.5V3.5Z" fill="#9CA1AA"/>
  </svg>
);

export default DocumentApprovedIcon;
